import ImageViewer from '@/components/image-viewer/index.vue';
export default {
  components: {
    ImageViewer
  },
  props: ['info'],
  data: () => {
    return {
    };
  },

  computed: {
    isNongji() {
      return this.info.category.indexOf('003') === 0;
    },
    images () {
      return this.info && this.info.executePhotos.map(item => item.image && item.image.preview) || [];
    }
  },

  created() {
  },

  methods: {
  }
};
